import { render } from "./AposEmptyState.vue?vue&type=template&id=0d1a1e22&scoped=true"
import script from "./AposEmptyState.vue?vue&type=script&lang=js"
export * from "./AposEmptyState.vue?vue&type=script&lang=js"

import "./AposEmptyState.vue?vue&type=style&index=0&id=0d1a1e22&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1a1e22"],['__file',"ui/ui/apos/components/AposEmptyState.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d1a1e22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d1a1e22', __exports__)) {
    api.reload('0d1a1e22', __exports__)
  }
  
  module.hot.accept("./AposEmptyState.vue?vue&type=template&id=0d1a1e22&scoped=true", () => {
    api.rerender('0d1a1e22', render)
  })

}


export default __exports__